module.exports = __webpack_public_path__ + "img/Date.278fb97d.svg";